exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-react-next/~/core-js/modules/_object-pie.js
// module id = ./node_modules/gatsby-plugin-react-next/node_modules/core-js/modules/_object-pie.js
// module chunks = 168707334958949